import { useState, useEffect } from "react";
import { GetDataPage, RegisterDataPage } from "interface/Data";
import { SetModalData, SetModalState } from "interface/PopUp";
import PopUP_ShowFile from "popUp";

/*
  left usa 50vw (centro real da viewport) + offsets em vh
  top usa valor fixo em vh (= 50% de list_video que começa em 12.5vh)
  Assim o layout é consistente em qualquer proporção de tela
*/
const SLOT_STYLES = [
    { left: 'calc(50vw - 72.135vh)', top: '24.145vh', width: '23.51vh', height: '39.21vh', zIndex: 0 },
    { left: 'calc(50vw - 50.94vh)',  top: '16.76vh',  width: '32.42vh', height: '53.98vh', zIndex: 1 },
    { left: 'calc(50vw - 20.835vh)', top: '9.03vh',   width: '41.67vh', height: '69.44vh', zIndex: 2 },
    { left: 'calc(50vw + 18.52vh)',  top: '16.76vh',  width: '32.42vh', height: '53.98vh', zIndex: 1 },
    { left: 'calc(50vw + 48.625vh)', top: '24.145vh', width: '23.51vh', height: '39.21vh', zIndex: 0 },
];

const SLOT_CLASSES = ['show_video_1', 'show_video_2', 'show_video_3', 'show_video_2', 'show_video_1'];

const TRANSITION = [
    'left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    'top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    'width 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    'height 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
].join(', ');

export default function App() {

    const [ language, setLanguage ] = useState('pt_br');

    const [ dataPage, setDataPage ] = useState(GetDataPage('data_site'));
    const [ centerIdx, setCenterIdx ] = useState(() => {
        const k = Object.keys(GetDataPage('data_site'));
        return Math.floor(k.length / 2);
    });
    const [ isAnimating, setIsAnimating ] = useState(false);

    useEffect(() => {
        RegisterDataPage('data_site', setDataPage);
    }, []);

    const keys = Object.keys(dataPage);
    const n = keys.length;

    // Maps a data key index to its current visual slot (0-4, center=2)
    const getSlot = (keyIndex) => ((keyIndex - centerIdx + n) % n + 2) % n;

    const handleCardClick = (slot) => {
        if (isAnimating) return;

        if (slot === 2) {
            OpenFile(dataPage[keys[centerIdx]].video);
            return;
        }

        const shiftMap = { 0: -2, 1: -1, 3: 1, 4: 2 };
        const shift = shiftMap[slot];
        if (shift === undefined) return;

        const newCenter = ((centerIdx + shift) % n + n) % n;
        setIsAnimating(true);
        setCenterIdx(newCenter);
        setTimeout(() => {
            setIsAnimating(false);
            OpenFile(dataPage[keys[newCenter]].video);
        }, 520);
    };

    function OpenFile(file){
        SetModalData('ShowFile', { "file": file });
        SetModalState('ShowFile', true);
    }

    function LineBreak(text){
        return text.split('\n').map((line, i) => (
            <span key={i} style={ line === 'hide' ? { visibility: 'hidden' } : {} }>
                { line === 'hide' ? '\u00A0' : line }
                <br />
            </span>
        ));
    }

    return (
        <div className="show_the_data_content">
            <div className="div_btn">
                <img alt="btn_01" className="btn_01_" src="./assets/img_btn_01.png" />
                <img alt="btn_02" className="btn_02_" src="./assets/img_btn_02.png" />
            </div>

            <div className="div_language">
                <div className={ language === 'pt_br' ? 'language_btn selected' : 'language_btn' } onClick={ () => setLanguage('pt_br') }>
                    PT-BR
                </div>
                <div className={ language === 'en' ? 'language_btn selected' : 'language_btn' } onClick={ () => setLanguage('en') }>
                    EN
                </div>
                <div className={ language === 'es' ? 'language_btn selected' : 'language_btn' } onClick={ () => setLanguage('es') }>
                    ES
                </div>
            </div>

            <div className="list_video">
                {
                    keys.map((key, i) => {
                        const slot = getSlot(i);
                        return (
                            <div key={ key } className={ 'show_video ' + dataPage[key].className + ' ' + SLOT_CLASSES[slot] } style={ { position: 'absolute', ...SLOT_STYLES[slot], backgroundImage: 'url("' + dataPage[key].img + '")', transition: TRANSITION, cursor: 'pointer', } } onClick={ () => handleCardClick(slot) } >                                
                                <img src={ dataPage[key].sub_img } className={ 'img_sub img_' + slot } />
                                <div className="space_height" />
                                <div className="subtitle">
                                    {
                                        language === 'pt_br' ? dataPage[key].subtitle_pt_br :
                                        language === 'en' ? dataPage[key].subtitle_en :
                                        language === 'es' ? dataPage[key].subtitle_es :
                                        dataPage[key].subtitle_pt_br
                                    }
                                </div>
                                <div className={ "title title_index_" + slot }>
                                    {
                                        LineBreak(
                                            language === 'pt_br' ? dataPage[key].title_pt_br :
                                            language === 'en' ? dataPage[key].title_en :
                                            language === 'es' ? dataPage[key].title_es :
                                            dataPage[key].title_pt_br
                                        )
                                    }
                                </div>

                                {
                                    slot === 2 &&
                                    <div className="icone_click">
                                        <svg className="click-svg" viewBox="0 0 100 125" fill="none">
                                            <path fill="#ffffff" d="M24.05219,63.77722l10.504,15.36566a22.34678,22.34678,0,0,0,7.54261,6.83765,3.77061,3.77061,0,0,1,1.8836,3.3006v3.36273A2.35611,2.35611,0,0,0,46.3385,95h22.144a2.35611,2.35611,0,0,0,2.35608-2.35614V86.26422a9.72882,9.72882,0,0,1,2.08631-5.91437,17.73556,17.73556,0,0,0,3.78106-10.86029l.004-12.54785a4.33174,4.33174,0,0,0-4.42487-4.5661h-.11084a4.04691,4.04691,0,0,0-4.31079,3.71484V52.48584a4.02349,4.02349,0,0,0-4.27447-3.71417l-.1258.00006c-2.46362,0-4.44335,1.71991-4.44335,3.84241l-.00165-3.45807a4.15378,4.15378,0,0,0-3.871-3.9596c-2.68664-.281-4.96984,1.53223-4.97009,3.81134l-.00043-18.1087a5.25107,5.25107,0,0,0-10.50213.00012v31.519l-7.65015-4.79864a6.25353,6.25353,0,0,0-5.86627-.41669C23.36682,58.52307,22.50476,61.51361,24.05219,63.77722Z"/>

                                            <rect className="dot-1" fill="#ffffff" x="24.27478" y="23.6499" width="8.87988" height="4" rx="1"/>

                                            <path className="dot-2" fill="#ffffff" d="M32.46536,9.74939H34.465a1,1,0,0,1,1,1v6.88065a.99994.99994,0,0,1-.99994.99994H32.46548a1.00006,1.00006,0,0,1-1.00006-1.00006V10.74933a.99994.99994,0,0,1,.99994-.99994Z" transform="translate(-0.2319 27.81954) rotate(-45)"/>
                                            
                                            <rect className="dot-3" fill="#ffffff" x="42.92517" y="5" width="4" height="8.86963" rx="1"/>
                                            
                                            <path className="dot-4" fill="#ffffff" d="M52.95655,12.185h6.86684a1,1,0,0,1,1,1v1.99957a1,1,0,0,1-1,1H52.95664a1,1,0,0,1-1-1V13.185A.99994.99994,0,0,1,52.95655,12.185Z" transform="translate(6.4872 44.03028) rotate(-45.00216)"/>

                                            <rect className="dot-5" fill="#ffffff" x="56.70544" y="23.6499" width="8.87012" height="4" rx="1"/>
                                        </svg>
                                    </div>
                                }
                                <div className="video_color" />
                            </div>
                        );
                    })
                }
            </div>

            <video className="bg_page" src="./assets/video/bg_page_01.mp4" autoPlay loop muted playsInline />

            <PopUP_ShowFile />
        </div>
    );
}
